var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "info lighten-1",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text subtitle-2"
  }, [_vm._v("브랜드 ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "accent",
      "fab": "",
      "dark": "",
      "small": "",
      "absolute": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.brandDialog.open();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1), _c('v-card-text', [_vm.brands.length ? _c('v-draggable-treeview', {
    attrs: {
      "item-key": "_id",
      "children": "children",
      "group": "brands",
      "dense": ""
    },
    on: {
      "click": _vm.change
    },
    model: {
      value: _vm.brands,
      callback: function ($$v) {
        _vm.brands = $$v;
      },
      expression: "brands"
    }
  }) : _c('span', [_vm._v("등록된 브랜드가 없습니다."), _c('br'), _vm._v("브랜드를 등록해주세요")])], 1)], 1), _c('v-row', [_c('v-spacer'), _c('v-col', {
    attrs: {
      "md": "auto"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "disabled": !_vm.brand._id
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("브랜드 기본정보")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "브랜드 이름",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.brand.name,
      callback: function ($$v) {
        _vm.$set(_vm.brand, "name", $$v);
      },
      expression: "brand.name"
    }
  }), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "브랜드 코드",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.brand.code,
      callback: function ($$v) {
        _vm.$set(_vm.brand, "code", $$v);
      },
      expression: "brand.code"
    }
  })], 1)], 1), _c('product-image', {
    attrs: {
      "label": "썸네일"
    },
    model: {
      value: _vm.brand.thumb,
      callback: function ($$v) {
        _vm.$set(_vm.brand, "thumb", $$v);
      },
      expression: "brand.thumb"
    }
  }), _c('product-image', {
    attrs: {
      "label": "서브 썸네일"
    },
    model: {
      value: _vm.brand.subThumb,
      callback: function ($$v) {
        _vm.$set(_vm.brand, "subThumb", $$v);
      },
      expression: "brand.subThumb"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "grey darken-1",
      "disabled": !_vm.brand._id || _vm.brand.root ? true : false
    },
    on: {
      "click": function ($event) {
        return _vm.remove(_vm.brand);
      }
    }
  }, [_vm._v("삭제")])], 1), _c('v-spacer'), _c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.brand._id
    },
    on: {
      "click": function ($event) {
        return _vm.update(_vm.brand);
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1)], 1), _c('brand-dialog', {
    ref: "brandDialog",
    on: {
      "save": _vm.search
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }